
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AppRating extends Vue {
  @Prop({ type: Boolean, default: false }) landing!: boolean;
  @Prop({ type: Boolean, default: false }) review!: boolean;
  @Prop({ type: Boolean, default: false }) forMatureUser!: boolean;
  @Prop({ type: Boolean, default: false }) mobile!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly isExperiment!: boolean;
}
